export const columns = [
  {
    title: "#",
    dataIndex: "id",
    key: "id",
    width: 50,
    customRender: (text, record, index) => {
      return index + 1;
    },
  },
  {
    title: "货代公司",
    dataIndex: "forwarder",
    key: "forwarder",
  },
  {
    title: "运输方式",
    dataIndex: "shippingType",
    key: "shippingType",
  },
  {
    title: "物流公司(API)",
    dataIndex: "logisticsCompanyCode",
    key: "logisticsCompanyCode",
    scopedSlots: {
      customRender: "logisticsCompanyCode",
    },
  },
  {
    title: "运输方式(API)",
    dataIndex: "channelNo",
    key: "channelNo",
    scopedSlots: {
      customRender: "channelNo",
    },
  },
  {
    title: "币种",
    dataIndex: "currencyType",
    key: "currencyType",
    scopedSlots: {
      customRender: "currencyType",
    },
  },
  {
    title: "面单尺寸",
    dataIndex: "size",
    key: "size",
    scopedSlots: {
      customRender: "size",
    },
  },
  {
    title: "操作",
    dataIndex: "id",
    key: "idAction",
    scopedSlots: {
      customRender: "action",
    },
  },
];


export const sheetSizeList = [
  {
    width: 70,
    height: 30,
    id:'7030'
  },
  {
    width: 100,
    height: 100,
    id:'100100'
  },
  {
    width: 100,
    height: 150,
    id:'100150'
  },
  {
    width: 150,
    height: 100,
    id:'150110'
  },
  {
    width: 107,
    height: 177,
    id:'107177'
  },
];
